import { render, staticRenderFns } from "./vListRecipeCost.vue?vue&type=template&id=c6260d34&scoped=true"
import script from "./vListRecipeCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./vListRecipeCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vListRecipeCost.vue?vue&type=style&index=0&id=c6260d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6260d34",
  null
  
)

export default component.exports